/**
 * Middleware to check if the user has access to the page
 * @param {Route} to
 */
export default defineNuxtRouteMiddleware(async (to) => {
    const { loggedIn } = useUserSession();
    if (!loggedIn.value || !to.path.startsWith('/members')) {
        return;
    }

    const profileStore = useUserProfileStore();

    await profileStore.fetchProfile(true);
    await profileStore.fetchLastUsedTeam();
});
